(function() {
  'use strict';

  function initNwFlavourV2Block(block) {
    const addButtons = block.querySelectorAll('.nw-flavour-v2-product-item-cta-button-button');
    const ctaButtonWrappers = block.querySelectorAll('.nw-flavour-v2-product-item-cta-button');
    const ctaQtyWrappers = block.querySelectorAll('.nw-flavour-v2-product-item-cta-qty');
    const qtyInputs = block.querySelectorAll('.nw-flavour-v2-product-item-cta-qty-input');
    const progressBar = block.querySelector('.nw-flavour-v2-tiered-pack-items-bar');
    const tierItems = block.querySelectorAll('.nw-flavour-v2-tiered-pack-item');

    function getTotalQuantity() {
      let total = 0;
      qtyInputs.forEach(function(input) {
        total += parseInt(input.value || 0, 10);
      });
      return total;
    }

    var addToCartBtn = block.querySelector('.nw-flavour-v2-add-to-cart-btn');

    function updateProgressBarAndTiers() {
      const totalQty = getTotalQuantity();

      var highestActiveTierIndex = -1;
      tierItems.forEach(function(item, index) {
        var tierQty = parseInt(item.getAttribute('data-quantity') || 0, 10);
        if (totalQty >= tierQty && tierQty > 0) {
          item.classList.add('active');
          highestActiveTierIndex = index;
        } else {
          item.classList.remove('active');
        }
      });

      var widthPercent = 0;
      if (highestActiveTierIndex === 0) widthPercent = 0;
      else if (highestActiveTierIndex === 1) widthPercent = 50;
      else if (highestActiveTierIndex === 2) widthPercent = 100;

      if (progressBar) {
        progressBar.style.setProperty('--width', widthPercent + '%');
      }

      if (addToCartBtn) {
        addToCartBtn.disabled = highestActiveTierIndex < 0;
      }

      // Determine purchase type
      var purchaseType = block.querySelector('input[name="purchase_type"]:checked');
      var isSubscription = purchaseType && purchaseType.value === 'subscription';

      // Get the active tier (or default to first)
      var activeTierIndex = highestActiveTierIndex >= 0 ? highestActiveTierIndex : 0;
      var activeTier = tierItems[activeTierIndex];

      if (activeTier) {
        // Read manually entered values from data attributes
        var subTotal = activeTier.getAttribute('data-sub-total') || '';
        var subPerBar = activeTier.getAttribute('data-sub-per-bar') || '';
        var subDiscountLabel = activeTier.getAttribute('data-sub-discount-label') || '';
        var otTotal = activeTier.getAttribute('data-ot-total') || '';
        var otPerBar = activeTier.getAttribute('data-ot-per-bar') || '';

        // Update subscription option card
        var discountEl = block.querySelector('.nw-flavour-v2-subscription-discount');
        var comparePriceEl = block.querySelector('.nw-flavour-v2-subscription-compare-price');
        var subscriptionPriceEl = block.querySelector('.nw-flavour-v2-subscription-price');
        var subscriptionPerBarEl = block.querySelector('.nw-flavour-v2-subscription-per-bar');

        if (discountEl) discountEl.textContent = subDiscountLabel;
        if (comparePriceEl) comparePriceEl.textContent = otTotal;
        if (subscriptionPriceEl) subscriptionPriceEl.textContent = subTotal;
        if (subscriptionPerBarEl) subscriptionPerBarEl.textContent = subPerBar;

        // Update one-time option card
        var oneTimePriceEl = block.querySelector('.nw-flavour-v2-one-time-price');
        var oneTimePerBarEl = block.querySelector('.nw-flavour-v2-one-time-per-bar');

        if (oneTimePriceEl) oneTimePriceEl.textContent = otTotal;
        if (oneTimePerBarEl) oneTimePerBarEl.textContent = otPerBar;
      }

      // Update tier subtitles based on purchase type
      tierItems.forEach(function(item) {
        var subtitle = item.querySelector('.nw-flavour-v2-tiered-pack-item-subtitle');
        if (subtitle) {
          if (isSubscription) {
            subtitle.textContent = item.getAttribute('data-price-text-each') || '';
          } else {
            subtitle.textContent = item.getAttribute('data-one-time-price-text-each') || '';
          }
        }
      });
    }

    function showAddButton(index) {
      ctaButtonWrappers[index].classList.remove('hidden');
      ctaQtyWrappers[index].classList.add('hidden');
      qtyInputs[index].value = 0;
      updateProgressBarAndTiers();
    }

    function showQtySelector(index) {
      ctaButtonWrappers[index].classList.add('hidden');
      ctaQtyWrappers[index].classList.remove('hidden');
      qtyInputs[index].value = 1;
      updateProgressBarAndTiers();
    }

    addButtons.forEach(function(btn, index) {
      btn.addEventListener('click', function() {
        showQtySelector(index);
      });
    });

    block.querySelectorAll('[data-minus]').forEach(function(btn, index) {
      btn.addEventListener('click', function() {
        var input = qtyInputs[index];
        var val = parseInt(input.value || 0, 10);
        if (val <= 1) {
          showAddButton(index);
        } else {
          input.value = val - 1;
          updateProgressBarAndTiers();
        }
      });
    });

    block.querySelectorAll('[data-plus]').forEach(function(btn, index) {
      btn.addEventListener('click', function() {
        var input = qtyInputs[index];
        var val = parseInt(input.value || 0, 10);
        input.value = val + 1;
        updateProgressBarAndTiers();
      });
    });

    // Listen for purchase type changes
    block.querySelectorAll('input[name="purchase_type"]').forEach(function(radio) {
      radio.addEventListener('change', function() {
        updateProgressBarAndTiers();
      });
    });

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function() {
        if (addToCartBtn.disabled) return;

        var purchaseType = block.querySelector('input[name="purchase_type"]:checked');
        var isSubscription = purchaseType && purchaseType.value === 'subscription';

        var highestActiveTierIndex = -1;
        tierItems.forEach(function(item, index) {
          if (item.classList.contains('active')) highestActiveTierIndex = index;
        });
        var activeTier = highestActiveTierIndex >= 0 ? tierItems[highestActiveTierIndex] : null;
        var sellingPlanId = isSubscription && activeTier ? activeTier.getAttribute('data-selling-plan-id') : null;

        var items = [];
        qtyInputs.forEach(function(input) {
          var qty = parseInt(input.value || 0, 10);
          if (qty > 0) {
            var variantId = input.getAttribute('data-id');
            if (variantId) {
              var item = { id: variantId, quantity: qty };
              if (sellingPlanId) item.selling_plan = sellingPlanId;
              items.push(item);
            }
          }
        });

        if (items.length === 0) return;

        addToCartBtn.classList.add('loading');
        var spinner = addToCartBtn.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function(response) {
          return response.json().then(function(data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function(result) {
            addToCartBtn.classList.remove('loading');
            addToCartBtn.querySelector('.loading__spinner').classList.add('hidden');
            
            // Refresh the cart drawer
            refreshCartDrawer();
        })
        .catch(function(err) {
          addToCartBtn.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
          console.error('Add to cart error:', err);
        });
      });
    }

    updateProgressBarAndTiers();
  }

  function refreshCartDrawer() {
    fetch(`${window.routes?.cart_url || '/cart'}?section_id=cart-drawer`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to refresh cart drawer: ${response.status} ${response.statusText}`);
        }
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const parsedDocument = parser.parseFromString(html, 'text/html');
        const cartDrawer = document.querySelector('cart-drawer');
        const newCartDrawer = parsedDocument.querySelector('cart-drawer');
        
        if (cartDrawer && newCartDrawer) {
          cartDrawer.replaceWith(newCartDrawer);
          newCartDrawer.classList.add('active');
        }
      })
      .catch(error => {
        console.error("Error during cart drawer refresh:", error);
      });
  }

  function init() {
    document.querySelectorAll('.nw-flavour-v2-block').forEach(initNwFlavourV2Block);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(e) {
    e.target.querySelectorAll('.nw-flavour-v2-block').forEach(initNwFlavourV2Block);
  });
})();
